import moment from "moment";
import React from "react"
import { useRef } from "react";
import { OverlayTrigger } from "react-bootstrap";
import { Popover } from "react-bootstrap";
import PtoButtonPanel from "./pto-button-panel";
import PtoStatusLabel from "./pto-status-label";
import { PTO_LEGEND_ARRAY, PTO_LEGEND_COLOR_MAP, PTO_STATUS } from "./_common";

const PtoDetailBox = (props) => {
    const { employee, calendarItem, ...rest } = props;
    const { typeCode, pto } = calendarItem;
    const overlayRef = useRef(null);

    if (pto) {
        const editButton = <i title="Edit Time-Off Request" className="fa fa-edit pull-right ap-clickable" style={{ fontSize: 14, color: "#809561" }}
            onClick={() => {
                if (props.onEdit) props.onEdit(calendarItem);
                overlayRef.current.hide();
            }}></i>;
        const canEdit = true;
        //const canEdit = pto.statusCode === PTO_STATUS.Requested;
        const total = `${pto.unit} hr(s)`;

        const title = (
            <div className="pto-popover-title">
                <p style={{ fontWeight: "bold" }}>{employee.fullName}
                    {canEdit ? editButton : null}
                </p>
                {
                    pto.ptoLines.length === 1 ?
                    <span style={{ display: "inline-block", width: 70, whiteSpace: "nowrap" }}>{moment(pto.ptoLines[0].actionDate).format("M/D/YYYY")}</span>:
                    <span style={{ display: "inline-block", width: 140, whiteSpace: "nowrap" }}>{moment(pto.ptoLines[0].actionDate).format("M/D/YYYY")} - {moment(pto.ptoLines[pto.ptoLines.length - 1].actionDate).format("M/D/YYYY")}</span>
                }
                <span>{total}</span> 
            </div>
        );

        const style1 = {
            padding: "5px 0px"
        };

        const style2 = {
            borderTop: "1px solid #EEE",
            padding: "5px 0px"
        };

        const hasButton = (pto.statusCode === PTO_STATUS.Approved && typeCode === "PTO") ||
            (pto.statusCode === PTO_STATUS.Requested);
        const id = `${employee.peopleId}_${calendarItem.expenses.length > 0 ? "E" + calendarItem.expenses[0].expenseId : "P" + calendarItem.pto.ptoId}`;
                
        const itemTypeTitle = calendarItem.title || (PTO_LEGEND_COLOR_MAP[calendarItem.typeCode] ? PTO_LEGEND_COLOR_MAP[calendarItem.typeCode].title : PTO_LEGEND_COLOR_MAP["MISC"].title);
        return (
            <OverlayTrigger id={`ptodetailbox_${id}`} ref={overlayRef} trigger="click" rootClose overlay={
                <Popover id={id} title={title} className="pto-popover">
                    <div className="ap-vert-flex-container pto-popover-content">
                        <div style={style1}>{itemTypeTitle}</div>
                        <div style={style2}><PtoStatusLabel pto={pto} /></div>
                        <div style={hasButton ? style2 : null}><PtoButtonPanel item={calendarItem} pto={pto} typeCode={calendarItem.typeCode} {...rest} /></div>
                    </div>
                </Popover>}>
                {props.children}
            </OverlayTrigger>
        );
    } else {
        return props.children;
    }
};

export default PtoDetailBox;